import React from "react";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router";
import classNames from "classnames";
import StudentsIndexlinks from "./indexLinks";
import { downloadFile } from "../../functions.js";
import { hasStaffRole, isTrainerContactOf } from "../../utils/auth";
import { fetcher } from "../../components/Overview/Overview";
import useSWR from "swr";
import { smoothScrollToTop } from "../../functions.js";
import { useDispatch } from "react-redux";
import { addGlobalMessage } from "../../actions/globalmessages";
import APP_CONFIG from "../../../app.config";

// utility function to make it possible to pass variations of indenting but remaining backwards compatible with old style
function forceIndentParse(passedIndent, fallback = false) {
    const forceIndent = passedIndent === false ? fallback : passedIndent;

    let indentClass = "";

    if (forceIndent > 1) {
        indentClass = `jumpin-${forceIndent}`;
    }
    if (forceIndent === 1) {
        indentClass = "jumpin";
    }
    return classNames({
        [indentClass]: forceIndent !== false
    });
}

export default class StudentsCourses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            examResults: [],
            open: [],
            courses: [],
            student: null
        };
    }

    getResults = () => {
        axios
            .all([
                axios.get("/v1/students/" + this.props.params.itemID + "/"),
                axios.get("/v1/users/" + this.props.params.itemID + "/courses/?limit=150"),
                axios.get("/v1/users/" + this.props.params.itemID + "/examtyperesults/")
            ])
            .then(
                axios.spread((student, courses, examResults) => {
                    this.setState({
                        loaded: true,
                        student: student.data,
                        courses: courses.data.results,
                        examResults: examResults.data.results
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount() {
        this.getResults();
    }

    /**
     * Toggle's the 'open' state of a key.
     * @param item
     */
    toggle(item) {
        const { open } = this.state;
        if (open.includes(item)) {
            this.setState({ open: open.filter((e) => e !== item) });
        } else {
            this.setState({ open: open.concat([item]) });
        }
    }

    render() {
        let resultHTML = <h2>Ophalen van gegevens...</h2>;

        if (this.state.loaded && this.state.courses) {
            const resultRows = [];

            this.state.courses.forEach((course) => {
                resultRows.push(
                    <CourseRow
                        course={course}
                        student={this.state.student}
                        user={this.props.authentication?.user}
                        key={course.uuid}
                        onClick={() => this.toggle(course.uuid)}
                        id={course.uuid}
                    />
                );
                const open = course.uuid === this.props.params.courseUUID || this.state.open.includes(course.uuid);
                if (!open) {
                    return;
                }
                course.competence_profile?.end_terms?.forEach((endTerm, j) => {
                    const etKey = `${course.uuid}-${j}`;
                    const open = this.state.open.includes(etKey);
                    resultRows.push(<EndTermRow endTerm={endTerm} course={course} open={open} onClick={() => this.toggle(etKey)} key={etKey} />);
                    if (!open) {
                        return;
                    }
                    endTerm.competences.forEach((competence, k) => {
                        const cKey = `${etKey}-${k}`;
                        resultRows.push(
                            <CompetenceRow competence={competence} student={this.state.student} course={course} progressResults={this.state.progressResults} key={cKey} />
                        );
                    });
                });

                // add result rows for all knowledge exams in this course
                course.events
                    .filter((event) => event.type === "knowledge-exam" && event.user_score)
                    .forEach((event) => {
                        event.user_score.forEach((result) => resultRows.push(<KnowledgeExamResultRow result={result} key={event.uuid + result.measurement.uuid} />));
                    });
            });

            if (resultRows.length > 0) {
                resultHTML = (
                    <>
                        <table className="table table-hover mt-3">
                            <thead>
                                <tr>
                                    <th width="120">Datum</th>
                                    <th>Cursus</th>
                                    <th>Opleider</th>
                                    <th width="140">Status</th>
                                    <th></th>
                                    <th width="110">Geldig tot</th>
                                </tr>
                            </thead>
                            <tbody>{resultRows}</tbody>
                        </table>
                    </>
                );
            } else {
                // We have 0 results
                resultHTML = <h2>Er zijn nog geen cursussen voor deze cursist.</h2>;
            }
        }

        return (
            <div>
                {this.state.student && (
                    <StudentsIndexlinks
                        title={this.state.student.full_name}
                        nibhv_number={this.state.student.nibhv_number}
                        studentUUID={this.props.params.itemID}
                        buttons={[{ title: "Cursist bewerken", link: "/students/edit/" + this.props.params.itemID, classname: "btn btn-primary" }]}
                    />
                )}

                {resultHTML}

                {this.state.examResults.length > 0 && (
                    <>
                        <h3 className="mt-4">Resultaten uit ExamenPortaal</h3>
                        <table className="table table-hover mt-3">
                            <thead>
                                <tr>
                                    <th width="120">Datum</th>
                                    <th>Examentype</th>
                                    <th>Examennummer</th>
                                    <th>Examentypenummer</th>
                                    <th width="110">Bedrijfsspecifiek</th>
                                    <th width="110">E-learning</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.examResults.map((result, i) => (
                                    <tr key={`result-${i}-${result.exam_id}-${result.trainer}`}>
                                        <td>{moment(result.date).format("DD-MM-YYYY")}</td>
                                        <td>{result.exam_type_name}</td>
                                        <td>{result.exam_id}</td>
                                        <td>{result.exam_type_id}</td>
                                        <td>
                                            <i
                                                className={classNames("fa", {
                                                    "fa-check green": result.employer_specific,
                                                    "fa-times text-danger": !result.employer_specific
                                                })}
                                            />
                                        </td>
                                        <td>
                                            <i
                                                className={classNames("fa", {
                                                    "fa-check": result.elearning,
                                                    "fa-times text-danger": !result.elearning
                                                })}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        );
    }
}

function CourseRow({ course, student, user, ...props }) {
    const courseStates = {
        new: "Nieuw",
        active: "Lopend",
        finished: "Afgerond",
        cancelled: "Geannuleerd",
        ended: "Afgelopen"
    };

    const certificates = course?.certifications?.sort((a, b) => (a.competence_profile.certification_name < b.competence_profile.certification_name ? 1 : -1));;

    const trainerDetails = [];
    if (course.trainer_details?.name) {
        trainerDetails.push(
            <Link key={course.uuid + course.trainer_details.uuid} to={`/trainers/edit/${course.trainer_details.uuid}`}>
                {course.trainer_details.name}
            </Link>
        );
    }
    if (course.trainer_details?.address) {
        trainerDetails.push(
            <span key={course.uuid + course.trainer_details.uuid + "location"} className="lighter">
                <br />
                {course.trainer_details.address}
            </span>
        );
    }
    if (course.trainer_details?.address) {
        trainerDetails.push(
            <span key={course.uuid + course.trainer_details.uuid + "city"} className="lighter">
                <br />
                {course.trainer_details.zipcode} {course.trainer_details.city}
            </span>
        );
    }

    const { latest_progress } = course.competence_profile;
    const dispatch = useDispatch();

    function handleDownloadCertificate(event, url, fileName = "") {
        event.stopPropagation();
        event.preventDefault();
        downloadFile(url, fileName);
    }

    const handleRerender = (url) => {
        axios.get(url).then((response) => {
            dispatch(addGlobalMessage({
                title: response.data.rerender
            }));
        }).catch((error) => {
            dispatch(addGlobalMessage({
                title: "Het opnieuw renderen van het certificaat is niet gelukt. Neem contact op met support.",
                type: "error",
            }));
        })
    }

    function handlePassRequest(event, url) {
        event.stopPropagation();
        event.preventDefault();

        try {
            axios
                .post(url, {
                    physical_pass: true
                })
                .then(() => {
                    dispatch(
                        addGlobalMessage({
                            title: "Physical pass is requested. Page will be reloaded soon."
                        })
                    );
                    smoothScrollToTop(600);
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                });
        } catch (error) {
            console.log(error);
        }
    }

    const courseStartDisplay = moment(course.course_datetime.start_datetime).format("DD-MM-YYYY");

    // We also need to be sure that the user is an actual trainer contact of the
    // course's trainer. Instructors are seeing the trainer details (as they are
    // authorized for the trainer) but are not allowed to see the course details.
    if (
        // If the user can't see trainer details (not authorized at all and not staff)
        !course.trainer_details ||
        // Or, if they can see the details, they also have to be a trainer contact in
        // order to see the course details. But staff users are also not a trainer
        // contact, but are allowed to see the course details.
        (!hasStaffRole(user?.roles) && !isTrainerContactOf(user, course.trainer_details.uuid))
    ) {
        // We are not allowed to access the course details, so just show any info we got
        return (
            <tr>
                <td>{courseStartDisplay}</td>
                <td>
                    <strong>
                        {course.id} - {course.display_name}
                    </strong>
                </td>
                <td>{trainerDetails.length ? trainerDetails : "-"}</td>
                <td colSpan="2">
                    <UserCourseStatusDisplay certificates={certificates} object={course.competence_profile} course={course} />
                </td>
                <td>
                    <ExpirationDate progress={latest_progress} />
                </td>
            </tr>
        );
    }

    return (
        <tr className="clickable" {...props}>
            <td>{courseStartDisplay}</td>
            <td>
                <Link to={`/courses/edit/${course.uuid}/students`}>
                    <strong>
                        {course.id} - {course.display_name}
                    </strong>
                </Link>
                <br />
                <span className="lighter">
                    {course.events.length} toetsmoment(en)
                    <br />
                    {courseStates[course.state] || "Onbekend"}
                    {certificates?.length > 0 && (
                        <React.Fragment>
                            <ul>
                                {certificates.map((certificate) => {
                                    if (certificate.state === "ready") {
                                        let hasMargin = false;

                                        if (certificate.competence_profile.parent) {
                                            hasMargin = true;
                                        }

                                        const url = APP_CONFIG.api_url + certificate.url;
                                        const urlRerender =
                                            APP_CONFIG.api_url +
                                            `/v1/users/${student.uuid}/courses/${course.uuid}/certificate/?competence_profile_uuid=${certificate.competence_profile.uuid}&rerender=true`;

                                        // const urlPassRequest = APP_CONFIG.api_url + `/v1/certifications/${certificate.uuid}/update_physical_pass/`;

                                        let digitalPassUrl = null;
                                        if (certificate.digital_pass_url) {
                                            digitalPassUrl = APP_CONFIG.api_url + certificate.digital_pass_url;
                                        }

                                        return (
                                            <li style={hasMargin ? { marginLeft: "10px" } : {}} key={certificate.uuid}>
                                                <a href="#" onClick={(e) => handleDownloadCertificate(e, url)}>
                                                    {certificate.competence_profile.certification_name} <i className="fa fa-download" />
                                                </a>
                                                <button
                                                    className="fa fa-refresh"
                                                    title="Certificaat opnieuw genereren"
                                                    onClick={(e) => handleRerender(urlRerender)}
                                                >
                                                    Certificaat opnieuw genereren
                                                </button>
                                                {digitalPassUrl && (
                                                    <button className="fa fa-ticket" title="Download digitale pas" onClick={(e) => handleDownloadCertificate(e, digitalPassUrl)}>
                                                        Download digitale pas
                                                    </button>
                                                )}
                                                {/*{!certificate.physical_pass && (*/}
                                                {/*    <button className="fa fa-ticket" title="Request physical pass" onClick={(e) => handlePassRequest(e, urlPassRequest)}>*/}
                                                {/*        Request physical pass*/}
                                                {/*    </button>*/}
                                                {/*)}*/}
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                            </ul>
                        </React.Fragment>
                    )}
                </span>
            </td>
            <td>{trainerDetails}</td>
            <td colSpan="2">
                <UserCourseStatusDisplay certificates={certificates} object={course.competence_profile} course={course} />
            </td>
            <td>
                <ExpirationDate progress={latest_progress} />
            </td>
        </tr>
    );
}

export function EndTermRow({ endTerm, course, open = false, forceIndent = false, statusFlip = false, ...props }) {
    const status = (
        <td key={1}>
            <StatusDisplay object={endTerm} course={course} exempted={endTerm.is_exempted} />
        </td>
    );
    const emptyRow = <td key={2}></td>;
    const expiration = (
        <td key={3}>
            <ExpirationDate progress={endTerm.latest_progress} />
        </td>
    );

    const statusExpiration = statusFlip ? [expiration, emptyRow, status] : [status, emptyRow, expiration];

    return (
        <tr className={forceIndentParse(forceIndent, 1) + " clickable"} {...props} key={endTerm.uuid}>
            <td colSpan={3}>
                <i className={classNames("fa", { "fa-angle-down": open, "fa-angle-right": !open })} />
                Eindterm: {endTerm.name}
            </td>
            {statusExpiration}
        </tr>
    );
}

export function CompetenceRow({ competence, allCompetences, endTerm, course, forceIndent = false, statusFlip = false, ...props }) {
    const status = (
        <td key={1}>
            <StatusDisplay object={competence} course={course} exempted={endTerm?.is_exempted} />
        </td>
    );

    // const knowledge_exam_event = course?.events.find((e) => e.type === "knowledge-exam" && e.user_score);
    const userScores = course?.events
        .filter((e) => e.type === "knowledge-exam" && e.user_score)
        .map((e) => e.user_score)
        .flat();
    const result = (
        <td key={2}>
            {endTerm?.is_exempted ? null : ( // when exempted, don't show any scores
                <CompetenceProgressItem allCompetences={allCompetences} competence={competence} userScores={userScores} />
            )}
        </td>
    );

    const expiration = (
        <td key={3}>
            <ExpirationDate progress={competence.latest_progress} />
        </td>
    );

    const statusExpiration = statusFlip ? [expiration, result, status] : [status, result, expiration];

    return (
        <tr className={forceIndentParse(forceIndent, 2)} {...props}>
            <td colSpan={3}>Competentie: {competence.name}</td>
            {statusExpiration}
        </tr>
    );
}

export function KnowledgeExamResultRow({ result, ...props }) {
    return (
        <tr className="jumpin" {...props}>
            <td colSpan={3}>
                <i className="fa fa-info" />
                {result.measurement.name}
            </td>
            <td colSpan={2}>{result.score.toFixed(1)}</td>
        </tr>
    );
}

function UserCourseStatusDisplay({ certificates, object, course, exempted = false, ...props }) {
    const achievedStates = ['exempted', 'achieved'];

    return (
        <span
            className={classNames({
                "text-success": achievedStates.includes(course?.user_status?.status),
                "text-danger": course?.user_status?.status === 'not_achieved'
            })}
            {...props}
        >
            <i
                className={classNames("fa", {
                    "fa-ellipsis-h": course?.user_status?.status === 'in_progress',
                    "fa-times": course?.user_status?.status === 'not_achieved',
                    "fa-check": achievedStates.includes(course?.user_status?.status)
                })}
            />{" "}
            {course?.user_status?.display.charAt(0).toUpperCase() + course?.user_status?.display.slice(1)}
        </span>
    );
}

function StatusDisplay({ certificates, object, course, exempted = false, ...props }) {
    const courseFinished = ["cancelled", "ended", "finished"].includes(course.state);

    const texts = {
        1: "Behaald",
        2: "Niet behaald",
        3: "Nog bezig...",
        4: "Vrijgesteld"
    };

    // fixme: having a certificate doesn't indicate if an end term is achieved. It could
    //  be a partial certificate which is achieved by other end terms.
    // const hasAchievedCertificate = certificates?.some(certificate =>
    //     certificate?.competence_profile?.uuid === course?.competence_profile?.uuid
    // );

    // const state = exempted
    //     ? 4
    //     : hasAchievedCertificate
    //         ? 1
    //         : courseFinished
    //             ? 2
    //             : 3;

    let state = 3; // in progress
    if (exempted) {
        state = 4; // exempted
    } else {
        state = object?.latest_progress?.is_achieved ?
            1 // achieved
            : (
                courseFinished
                    ? 2 // course is finished, not achieved
                    : 3 // course isn't finished yet, in progress
            );
    }

    const achievedStates = [1, 4];

    return (
        <span
            className={classNames({
                "text-success": achievedStates.includes(state),
                "text-danger": state === 2
            })}
            {...props}
        >
            <i
                className={classNames("fa", {
                    "fa-ellipsis-h": state === 3,
                    "fa-times": state === 2,
                    "fa-check": achievedStates.includes(state)
                })}
            />{" "}
            {texts[state]}
        </span>
    );
}

function CompetenceProgressItem({ competence, allCompetences, userScores }) {
    let score_type_display = "";
    let color = "";

    const fullCompetence = allCompetences?.find((comp) => comp.competence.uuid === competence.uuid && comp.measurement.measurement_type === "practice");

    const scoreTypes = {
        good: "Goed",
        sufficient: "Voldoende",
        to_be_improved: "Voor verbetering vatbaar",
        insufficient: "Onvoldoende"
    };

    if (fullCompetence) {
        score_type_display = scoreTypes[fullCompetence.score_type_slug];
        color = fullCompetence.score_type_slug;
    } else {
        const matchingMeasurement = userScores?.find((item) => item.measurement.competence.uuid === competence.uuid);
        score_type_display = matchingMeasurement?.score;
    }

    return (
        <div className="result-block">
            <div className="result-block-title">
                <span>
                    <span className={color}>{score_type_display}</span>
                </span>
            </div>
        </div>
    );
}

function ExpirationDate({ progress }) {
    const expirationDate = progress?.is_achieved && progress?.expiration_date ? moment(progress.expiration_date) : null;
    return (expirationDate && <time dateTime={expirationDate.toISOString()}>{expirationDate.format("DD-MM-YYYY")}</time>) || "N.v.t";
}
